import AbstractNode from './AbstractNode';
import {escapeHtml} from '../../Common/escapeHtml';

export default class Image extends AbstractNode {
    get name() {
        return "image";
    }

    get schema() {
        return {
            inline: true,
            attrs: {
                src: {},
                alt: {default: null},
                title: {default: null},
                width: {default: null},
                height: {default: null},
                ['data-id']: {default: null},
                ['data-diagram']: {default: null},
            },
            group: "inline",
            draggable: true,
            parseDOM: [{
                tag: "div[class~=image]",
                getAttrs: dom => {
                    const img = dom.getElementsByTagName("img")[0];
                    return {
                        src: img?.getAttribute("src"),
                        alt: img?.getAttribute("alt"),
                        title: img?.getAttribute("title"),
                        width: img?.getAttribute("width"),
                        height: img?.getAttribute("height"),
                        ['data-id']: img?.getAttribute("data-id"),
                        ['data-diagram']: img?.hasAttribute("data-diagram") || null,
                    };
                },
            }, {
                tag: "img[src]", getAttrs: token => {
                    return {
                        src: token.getAttribute("src"),
                        title: token.getAttribute("title"),
                        alt: token.getAttribute("alt"),
                        width: token.getAttribute("width") || token.getAttribute("naturalWidth"),
                        height: token.getAttribute("height") || token.getAttribute("naturalHeight"),
                        ['data-id']: token.getAttribute("data-id"),
                        ['data-diagram']: token.hasAttribute("data-diagram") || null,
                    }
                }
            }],
            toDOM: node => {
                return ["img", node.attrs];
            }
        }
    }

    toMarkdown(state, node) {
        state.write("![");
        state.write(state.esc(node.attrs.alt || ""));
        state.write("](");
        state.write(state.esc(node.attrs.src));

        if (node.attrs.title) {
          state.write(" ");
          state.write(state.quote(node.attrs.title));
        }

        state.write("){");
        state.write('width="');
        state.write(node.attrs.width);
        state.write('" height="');
        state.write(node.attrs.height);
        state.write('"');

        if (node.attrs['data-id']) {
          state.write(' data-id="');
          state.write(escapeHtml(node.attrs['data-id']));
          state.write('"');
        }

        if (node.attrs['data-diagram']) {
          state.write(' data-diagram="true"');
        }

        state.write("}");
    }

    get parseMarkdown() {
        return {
            node: "image", getAttrs: token => {
                const attributes = {
                    src: token.attrGet("src"),
                    alt: token.children && token.children[0] && token.children[0].content || ""
                };
                if (token.attrGet("title")) {
                    attributes.title = token.attrGet("title");
                }
                if (token.attrGet("width")) {
                    attributes.width = token.attrGet("width");
                }
                if (token.attrGet("height")) {
                    attributes.height = token.attrGet("height");
                }
                if (token.attrGet("data-id")) {
                  attributes['data-id'] = token.attrGet("data-id");
                }
                if (token.attrGet("data-diagram")) {
                  attributes['data-diagram'] = true;
                }

                return attributes;
            }
        }
    }

    commands({schema}) {
      return {
        createDrawIoDiagram: (src, width, height) => view => {
          view.dispatch(view.state.tr.replaceSelectionWith(schema.nodes.image.create({
            height,
            width,
            src,
            title: 'draw.io diagram',
            'data-diagram': true
          })).scrollIntoView());
        }
      }
    }
}